import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import WorldXIcon from "@/assets/icons/svg/world-x.icon.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'browser-not-supported-warning-dialog',
  props: {
    isVisible: { type: Boolean },
    onClose: null,
    forExam: { type: Boolean },
    forCourseWork: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isVisible: boolean;
  onClose: () => void;
  forExam?: boolean;
  forCourseWork?: boolean;
}



const closeDialog = () => {
  props.onClose();
};

return { __sfc: true,props, closeDialog, BaseDialog, WorldXIcon }
}

})